import { render, staticRenderFns } from "./DistributorsTable.vue?vue&type=template&id=1e904690&"
import script from "./DistributorsTable.vue?vue&type=script&lang=js&"
export * from "./DistributorsTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports